export const brandConfig = {
  brandName: "WaBM",
  brandShortName: "WaBM",
  companyName: "Infokey Technology Private Limited",
  googleLocation:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3499.4332057382803!2d77.12964008098821!3d28.706596912773517!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d03d87b7f1f31%3A0x8b7801933e3d84bd!2sBlock%20AD%2C%20Dakshini%20Pitampura%2C%20Pitampura%2C%20Delhi!5e0!3m2!1sen!2sin!4v1728206463804!5m2!1sen!2sin",

  websites: {
    website1: "https://wabm.in",
    website2: "",
    shop1: "",
    shop2: "",
  },

  contactInfo: {
    email1: "hi@wabm.in",
    email2: "support@wabm.in",
    phone1: "+91 922064 5544",
    phone2: "+91 9718 665000",
    whatsapp1: "+91 922064 5544",
    whatsapp1Link: "https://api.whatsapp.com/send?phone=919220645544",
    whatsapp2: "+91 9718 665000",
    whatsapp2Link: "https://api.whatsapp.com/send?phone=919718665000",
  },

  socialProfiles: {
    instagram: "https://www.instagram.com/wabm.in",
    instagramUsername: "@wabm.in",
    facebook: "https://www.facebook.com/wabm.in",
    facebookUsername: "@wabm_in",
    twitterX: "",
    twitterXUsername: "",
    linkedIn: "https://www.linkedin.com/showcase/wabm",
    linkedInUsername: "/showcase/wabm",
  },
};
